import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from '@heroicons/react/24/solid';

const PricingPage = () => {
  const plans = [
    {
      name: 'STARTER',
      price: 'Gratuit',
      period: '/mois',
      description: 'Pour débuter et tester la plateforme sans risque.',
      features: [
        'Profil de base',
        '5 réservations/mois',
        'Paiements sécurisés',
        'Support email',
      ],
      cta: 'Commencer gratuitement',
      variant: 'secondary',
    },
    {
      name: 'SMART PRO',
      price: '5000 FCFA',
      period: '/mois',
      description: 'Pour les prestataires sérieux qui veulent développer leur clientèle.',
      features: [
        'Profil premium mis en avant',
        'Réservations illimitées',
        'Paiements prioritaires',
        'Analytics complets',
        'Badge Smart vérifié',
        'Support prioritaire 7j/7',
      ],
      cta: 'Choisir Smart Pro',
      variant: 'primary',
      popular: true,
    },
    {
      name: 'ENTREPRISE',
      price: 'Sur devis',
      period: '',
      description: 'Pour les entreprises avec plusieurs prestataires.',
      features: [
        'Gestion d\'équipe',
        'Tableau de bord multi-profil',
        'API d\'intégration',
        'Account manager dédié',
        'Facturation mensuelle',
        'SLA garanti',
      ],
      cta: 'Nous contacter',
      variant: 'secondary',
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-display font-bold mb-4">Des offres adaptées à chaque niveau</h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Commencez gratuitement. Passez à un plan premium pour plus de visibilité et de fonctionnalités.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`card relative ${
                plan.popular ? 'ring-2 ring-primary-500 scale-105' : ''
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary-500 text-white px-4 py-1 rounded-full text-sm font-medium">
                  Populaire
                </span>
              )}
              
              <div className="text-center mb-6">
                <h3 className="text-lg font-semibold text-gray-500 mb-2">{plan.name}</h3>
                <div className="mb-2">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-500">{plan.period}</span>
                </div>
                <p className="text-sm text-gray-500">{plan.description}</p>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-center space-x-3">
                    <CheckIcon className="h-5 w-5 text-primary-500 flex-shrink-0" />
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-3 rounded-full font-semibold transition ${
                  plan.variant === 'primary'
                    ? 'bg-primary-500 text-white hover:bg-primary-600'
                    : 'bg-white text-primary-500 border-2 border-primary-500 hover:bg-primary-50'
                }`}
              >
                {plan.cta}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPage;